<div class="lp-wrapper">
  <div *ngIf="loading" class="lp-status">Loading…</div>
  <div *ngIf="!loading && errorMsg" class="lp-status lp-error">{{ errorMsg }}</div>

  <ngx-charts-bar-vertical-2d
    *ngIf="!loading && !errorMsg"
    [results]="chartData"
    [view]="viewsize"
    [xAxis]="showXAxis"
    [yAxis]="showYAxis"
    [legend]="showLegend"
    [showXAxisLabel]="showXAxisLabel"
    [showYAxisLabel]="showYAxisLabel"
    [xAxisLabel]="xAxisLabel"
    [yAxisLabel]="yAxisLabel"
    [trimXAxisTicks]="false"
    [trimYAxisTicks]="false">
  </ngx-charts-bar-vertical-2d>
</div>
